import {
  CreateRecaudacionRequestSchema,
  RecaudacionListQuerySchema,
  RecaudacionSchema,
  UpdateRecaudacionRequestSchema,
} from '@visep/shared-types/recaudacion';
import type { Helpers } from './internal.js';
import { makeCrudResource } from './internal.js';

export function createRecaudacionResource({ request }: Helpers) {
  const crud = makeCrudResource(request, {
    basePath: '/api/recaudacion',
    schema: RecaudacionSchema,
    listQuerySchema: RecaudacionListQuerySchema,
    createSchema: CreateRecaudacionRequestSchema,
    updateSchema: UpdateRecaudacionRequestSchema,
  });
  return { ...crud };
}
